<template>
  <div>
    <div class="mask"  ref="maskPosition" v-show="showMenu">
      <div class="dialog">
        <div style="height:3.52rem ">
          <p class="dialog-title">
            <span>重命名</span>
            <span style="color: red;display: block;font-size: 0.32rem;" v-show="errorInfo">{{errorInfo}}</span>
          </p>
          <p class="dialog-content" >
            <!--<input type="text" ref="inputA" v-model.trim="fileName" v-focus="this.$store.getters.getDialogIsShow">-->
            <textarea  type="text" ref="inputA" v-model.trim="fileName" @focus="focusAbsolute()" @blur="blurFixed()" :style="{height:textarea ? '1.4rem' : '0.8rem'}"></textarea>
            <!--<input  type="text" ref="inputA" v-model.trim="fileName" :style="{display:(/(iPad|iPhone|iPod)/g.test(isNotIOS)) ? 'none' : 'block'}">-->
          </p>
        </div>
        <p class="dialog-button">
          <span class="cancel" @click="cancel">取消</span><span class="ok" @click="ok" >确定</span>
        </p>
      </div>
    </div>
    <transition name="sideUp">
      <confirm-tips  :tipTitle="tipTitle" :clickCallBack="renameFile" :tipsType="tipsType" :okBtnText="okBtnText"></confirm-tips>
    </transition>
    <transition name="sideUp">
      <confirm-tips  :tipTitle="extensionTitle" :clickCallBack="extensionTips" :tipsType="extensionType"></confirm-tips>
    </transition>
  </div>
</template>

<script>
  import store from 'store'
  import * as Util from 'util'
  import tips from 'tips'
  export default {
    props: {
      dialogTitle: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        isShow: true,
        nameIndex: '',
        errorInfo: '',
        extensionReg: '',
        fileName: '',
        tipTitle: '',
        tipsType: 'confirmRename',
        okBtnText: '继续',
        extensionTitle: '如果改变文件扩展名，可能会导致文件不可用。确实要更改吗？',
        extensionType: 'extensionConfirm',
        textarea: ''
      }
    },
    directives: {
      focus: {
        update: function (el, {value}) {
          if (value) {
            el.scrollIntoView(true)
            el.focus()
          }
        }
      }
    },
//    mounted () {
//      this.$refs['inputA'].focus()
//      // this.$refs['input'].value = ''
//    },
    methods: {
      stopTouch (event) {
        return
      },
//      onf (event) {
//        event.currentTarget.focus()
//        event.currentTarget.select()
//      },
      focusAbsolute () {
        var isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent)           // 解决ios光标错位
        var scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
        if (isIOS) {
          if (scrollHeight > 0) {
            // document.body.scrollTo(0, 0)
            document.body.scrollTop = 0
            window.scrollTo(0, 300)
          } else {
            window.scrollTo(0, 0)
          }
          this.$refs.maskPosition.style.position = 'absolute'
        }
      },
      blurFixed () {
        this.$refs.maskPosition.style.position = 'fixed'
      },
      ok () {
        this.errorInfo = Util.validFilename(this.fileName)
        if (this.errorInfo) {
          return
        }
        var oldExtension = this.$store.getters.getCurrentFile.name.substr(this.$store.getters.getCurrentFile.name.lastIndexOf('.'))
        var newExtension = this.fileName.substr(this.fileName.lastIndexOf('.'))
        if (newExtension.indexOf('.') > -1 && oldExtension !== newExtension) {
          store.commit('showConfirmTips', 'extensionConfirm')
        } else {
          this.commitData()
          this.hideDialogList()
        }
      },
      extensionTips () {
        this.commitData()
        this.hideDialogList()
      },
      renameFile () {
        this.commitData()
        this.hideDialogList()
      },
      hideDialogList () {
        store.commit('hideRenameDialog')
      },
      cancel () {
        this.hideDialogList()
        this.errorInfo = ''
      },
      highlight () {
        this.nameIndex = this.fileName.lastIndexOf('.')
        if (this.$store.getters.getCurrentFile.is_dir) {
          this.nameIndex = this.fileName.length
        }
        //  文件名默认选中
        // if (this.$store.getters.getRenameIsShow) {
        //   setTimeout(function () {
        //     self.$refs.inputA.scrollIntoView(true)
        //   }, 400)
        //   this.$refs.inputA.setSelectionRange(0, this.nameIndex > 0 ? this.nameIndex : this.fileName.length)
        //   this.$refs.inputA.focus()
        // }
        // 高亮文件名，不包括文件后缀
        if (this.nameIndex !== -1) {
//          this.$refs.inputA.select(0, this.nameIndex)
          // 考虑更改文件后缀名
          var sss = this.fileName.substr(this.nameIndex) + '$'
          if (/\)/.test(sss)) {
            sss = sss.replace(')', '\\)')
          }
          if (/\[/.test(sss)) {
            sss = sss.replace('[', '\\[')
          }
          if (/\{/.test(sss)) {
            sss = sss.replace('{', '\\{')
          }
          this.extensionReg = new RegExp('.' + sss)
        } else {
          this.extensionReg = new RegExp('.')
        }
        console.log(this.extensionReg)
      },
      commitData () {
        if (this.nameIndex !== -1 && this.extensionReg.test(this.fileName)) {
          var currentFile = this.$store.getters.getCurrentFile
          if (currentFile.name === this.fileName) {
            return
          }
          if (this.$store.getters.getFullPath === '/') {
            currentFile.to_path = this.$store.getters.getFullPath + this.$refs.inputA.value
          } else {
            currentFile.to_path = this.$store.getters.getFullPath + '/' + this.$refs.inputA.value
          }
          currentFile.to_path_type = currentFile.path_type
          store.dispatch('renameFileName', currentFile)
        }
      }
    },
    computed: {
      showMenu () {
        var self = this
        if (this.$store.getters.getRenameIsShow) {
          this.fileName = this.$store.getters.getCurrentFile.name
        }
        if (this.$store.getters.getRenameIsShow) {
          setTimeout(function () {
            self.highlight()
          }, 2000)
        }
        return this.$store.getters.getRenameIsShow ? this.$store.getters.getRenameIsShow : false
      }
    },
    created () {
    },
    updated () {
      this.highlight()
    },
    watch: {
      '$store.state.fileInfo.tipsTitle': function (val, oldVal) {
        this.tipTitle = val
        store.commit('showConfirmTips', 'confirmRename')
      },
      fileName: {
        handler: function (newValue) {
          // var isIOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent)
          if (newValue.replace(/[^\x00-\xff]/g, '01').length > 24) {
            this.textarea = true
          } else {
            this.textarea = false
          }
        },
        deep: true
      }
    },
    components: {
      'confirm-tips': tips
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">
textarea
  height: .8rem
  line-height: .8rem
  width: 6.15rem
  padding-left 0.18rem
  border: none
  background: transparent
  overflow-y: scroll
</style>



// WEBPACK FOOTER //
// filelist_rename.vue?055a57ab